module.exports = __webpack_public_path__ + "img/paper_download.3770dc9a.svg";